import {addFavorite, deleteFavorite, deleteOldFavourite, getPlayerIdFromHeader} from "../spirsApi/api-client";
import {useSelector} from "react-redux";
import {StoreType} from "../store/spirs/types";
import {Dispatch, useEffect, useState} from "react";
import {SET_FAVORITES_COUNT} from "../store/spirs/actions";
import {FavoritesResultType} from "../models/api/codegen/code";

export const useFavorites = (initFixtureId: number, dispatch: Dispatch<any>, initFavorite?: boolean, callback?: any) => {
    const [fixtureId, setFixtureId] = useState(initFixtureId);
    const [isFavorite, setFavorite] = useState<boolean>(initFavorite ? initFavorite : false);
    //playerId берется из хедера, т.к. кладется туда без запроса playerInfo, который делается только для участников с возможностью осуществлять шаги
    const playerId = getPlayerIdFromHeader();
    const favoritesAmount = useSelector((state: StoreType) => state.spirs.favoritesCount);

    useEffect(() => {
        setFavorite(initFavorite ? initFavorite : false)
    }, [initFavorite]);

    useEffect(() => {
        setFixtureId(initFixtureId);
    }, [initFixtureId]);

    const onChange = () => {
        if (!playerId) {
            return;
        }
        isFavorite ? deleteFixtureAsFavorite() : resolveFavouriteAmount();
    }

    const addFixtureAsFavorite = () => addFavorite({filter: {fixtureId, playerId}})
        .then((res) => res && changeState(res));

    const deleteFixtureAsFavorite = () => deleteFavorite({filter: {fixtureId, playerId}})
        .then((res) => res && changeState(res));

    const deleteOldestFavourite = () => deleteOldFavourite({filter: {playerId}})
      .then((res) => res && changeState(res));

    const resolveFavouriteAmount = () => {
        if (favoritesAmount > 49) {
            deleteOldestFavourite().then(addFixtureAsFavorite);
        } else {
            addFixtureAsFavorite().then(r => r);
        }
    }

    const changeState = (result: FavoritesResultType) => {
        if (result.ok) {
            setFavorite(prevState => !prevState);
        }
        dispatch(SET_FAVORITES_COUNT(result.count));
        callback && callback()
    };

    return {isFavorite, onChange}
};
